import apiClient from '../assets/common/interceptor';
import { useMutation } from '@tanstack/react-query';

export const placeOrder = (data) => {
  try {
    return apiClient.post('/organisation/order', data).then((response) => response.data);
  } catch (error) {
    throw new Error(error);
  }
};

export const usePlaceOrder = ({ ...queryOptions } = {}) => {
  return useMutation({ 
    ...queryOptions,
    mutationFn: (data) => placeOrder(data), 
  });
};